'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002eutils$0024$002dChange$002dSet from "./presto.utils$-Change-Set.js";
var $p;
/** @constructor */
function $c_Lpresto_utils$ChangeSet$() {
}
export { $c_Lpresto_utils$ChangeSet$ as $c_Lpresto_utils$ChangeSet$ };
$p = $c_Lpresto_utils$ChangeSet$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_utils$ChangeSet$;
/** @constructor */
function $h_Lpresto_utils$ChangeSet$() {
}
export { $h_Lpresto_utils$ChangeSet$ as $h_Lpresto_utils$ChangeSet$ };
$h_Lpresto_utils$ChangeSet$.prototype = $p;
$p.acm = (function() {
  return new $j_presto$002eutils$0024$002dChange$002dSet.$c_Lpresto_utils$ChangeSet($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aD(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aD(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aD());
});
var $d_Lpresto_utils$ChangeSet$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_utils$ChangeSet$, "presto.utils$ChangeSet$", ({
  a4N: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_utils$ChangeSet$ as $d_Lpresto_utils$ChangeSet$ };
var $n_Lpresto_utils$ChangeSet$;
function $m_Lpresto_utils$ChangeSet$() {
  if ((!$n_Lpresto_utils$ChangeSet$)) {
    $n_Lpresto_utils$ChangeSet$ = new $c_Lpresto_utils$ChangeSet$();
  }
  return $n_Lpresto_utils$ChangeSet$;
}
export { $m_Lpresto_utils$ChangeSet$ as $m_Lpresto_utils$ChangeSet$ };
//# sourceMappingURL=presto.utils$-Change-Set$.js.map
